// @flow

import type { State } from "@store/reducers";
import type { ApprovableContainer, HierarchyAssignment } from "@modules/service/types";
import type { Rtw, RTWProcessesData, RTWFilterStateType } from "@modules/service/reducer/rtw/types";
import { validateHierarchyAssignmentSchema } from "./index";

export type GetRtwListType = (state: State) => Array<Rtw>;

// RTW CRUD

export const getRTWLiveProcessesFilter = (state: State): RTWFilterStateType =>
  state.service.rtw.liveProcessesFilter;

export const getRtwProcessesDataSelector = (state: State): RTWProcessesData =>
  state.service.rtw.list;

export const currentRtw = (state: State): ?ApprovableContainer<Rtw> => state.service.rtw.current;

export const getRtwDraft = (state: State): ?Rtw => state.service.rtw.draft;

export const getRtwAssignments = (state: State): Array<HierarchyAssignment> =>
  state.service.rtw.assignments;

export const getRtwDraftAssignments = (state: State): Array<HierarchyAssignment> =>
  state.service.rtw.draftAssignments;

export const isRtwDraftAssignmentsValid = (state: State): boolean => {
  const assignments = getRtwDraftAssignments(state);
  return validateHierarchyAssignmentSchema(assignments);
};

export const isRtwAssignmentsValid = (state: State): boolean => {
  const assignments = getRtwAssignments(state);
  return validateHierarchyAssignmentSchema(assignments);
};

// RTW SCHEMA

export const getRtwSchema = (state: State): Object | null => state.service.rtw.schema;

// RTW CONFIG

export const getRtwEnabled = (state: State): boolean => state.service.rtw.configuration.enabled;

export const getRtwStatus = (state: State) => state.service.rtw.configuration.status;

// RTW MODALS

export const getShowRtwAddAttachmentModal = (state: State): boolean =>
  state.service.rtw.modals.showAddRtwAttachmentModal;

export const getAddFileInProgress = (state: State): boolean => {
  return state.service.rtw.addFileInProgress;
};
